import React, {useRef} from "react";

import CursorItemsCoordinatorShared from '../../../../shared/itemLists/CursorItemsCoordinator'
import Cursor from './Cursor'

export default function CursorItemsCoordinator(props){
  
  const containerRef = useRef(null)
  function renderPlatformedCoordinator({handleWheel,
                                       cursorTop,
                                       scrollGutterHeight}) {
    return (
      <div
        className="Cursor-items-coordinator"
        onWheel={handleWheel}
        ref={containerRef}
        >
        {renderCursor(cursorTop)}
        {props.renderItemsList({})}
        <div
          className="scroll-gutter"
          style={{ height: scrollGutterHeight + "px" }}
          />
      </div>
    )
  }

  function renderCursor(cursorTop){
    if(props.hideCursor) return null
    return <Cursor cursorTop={cursorTop}></Cursor>
  }

  function scrollContainerTo({top, behavior}){
      containerRef.current.scrollTo({
        top, behavior
      })
  }
  function getContainerScrollTop(){
    return containerRef.current.scrollTop
  }
  function getClientHeight() {
    if (containerRef.current == null) {
      return 0;
    }
    return containerRef.current.clientHeight;
  }
  return (
    <CursorItemsCoordinatorShared 
      {...props} 
      {...{renderPlatformedCoordinator, 
          scrollContainerTo,
          getContainerScrollTop,
          getClientHeight
      }}
    />
  )
}